import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "./accountAlerts.css";
import Widget from '../../Shared/Widget';
import { isMobile } from '../../helpers/utils';
import { Row, Col } from 'react-bootstrap';
import LoadingMask from "../../Shared/LoadinngMask/LoadingMask";
import { LoadingState } from "../../helpers/enum";
import BackButton from '../../Shared/BackButton';
import { Header } from '../../Shared';
import LinkButton from "../../Shared/LinkButton/index";

class AccountAlertsPage extends Component {
    constructor(props) {
        super(props);
        this.accountno = props.match.params.accountno;
        this.nickname = props.match.params.nickname;
        this.name = props.match.params.name;
    }

    componentWillMount() {
        this.props.getAccountAlertTypes(this.accountno);
    }

    componentDidMount() {
        this.props.accountAlerts();
    }

    componentDidUpdate() {
        setTimeout(() => {
            var root = document.getElementById("root");

            var _event = {};

            _event = {
                name: 'END_SETTING_HEIGHT',
                height: root.parentElement.parentElement.offsetHeight
            };

            //Post END Height Event for OLB 
            window.parent.postMessage(_event, '*')
        },
            0)
    };


    render() {
        const { accountAlertTypes = {} } = this.props;
        const Heading = [this.name];
        const loadingStates = [];
        const widgets = [accountAlertTypes.items];
        const baseRoutes = [`#/accountalerttypes`]
        const propNames = ['name', 'number']

        if (accountAlertTypes.loadingState === LoadingState.FULFILLED) {
            return (
                <div>
                    <div aria-live="polite">
                        {this.props.accountAlertState === LoadingState.PENDING && <LoadingMask ctrlCss="overlay" />}
                    </div>
                    <div className={isMobile() ? `mobilecontainer-box mobile-font-family` : `container-box`} >
                        <BackButton
                            href="#/landingPage"
                            text="Notification Center"
                        />                 


                        <Row>                        
                            {                              
                                widgets.map((widget, i) => (
                                    <Col key={i} className={`${isMobile() ? 'col-mobile' : 'col-lg-4 col-md-4'}`}>
                                        <Widget
                                            details={widget}
                                            heading={Heading[i]}
                                            isLoadingOrError={loadingStates[i]}
                                            route={baseRoutes[i]}
                                            propNames={propNames[i]}
                                            subRoute={i === 2 ? ["addOrEditMethodComponent", "manage"] : ""}
                                            accountNumber={this.accountno}
                                            accountAlertName={this.name}
                                            nickname={this.nickname}
                                        />
                                    </Col>
                                ))
                            }
                        </Row>

                        <div className="padding-top">
                            <LinkButton
                                text="Add / Edit Delivery Methods"
                                href="#/alertPreferences/addOrEditMethodComponent"
                            />
                        </div>

                    </div>
                </div>
            );
        }
        else {
            return <LoadingMask ctrlCss="fullpage" />;
        }
    }

}

export default withRouter(AccountAlertsPage);
